//import liraries
import React, { Component } from 'react';
import { View, Text } from 'react-native';
import { STheme } from 'servisofts-component2';

const DATA = [
    {
        "lEstadoExpedicion_id": 1,
        "sDescripcion": "ANUNCIADA",
        "sCodigo": "AN",
        "iColorR": 245,
        "iColorV": 230,
        "iColorA": 5
    },
    {
        "lEstadoExpedicion_id": 2,
        "sDescripcion": "EN PROCESO",
        "sCodigo": "S",
        "iColorR": 255,
        "iColorV": 255,
        "iColorA": 255
    },
    {
        "lEstadoExpedicion_id": 2,
        "sDescripcion": "EN SERVICIO",
        "sCodigo": "S",
        "iColorR": 255,
        "iColorV": 255,
        "iColorA": 255
    },
    {
        "lEstadoExpedicion_id": 3,
        "sDescripcion": "REALIZADA",
        "sCodigo": "R",
        "iColorR": 65,
        "iColorV": 238,
        "iColorA": 9
    },
    {
        "lEstadoExpedicion_id": 4,
        "sDescripcion": "ANULADA",
        "sCodigo": "A",
        "iColorR": 255,
        "iColorV": 99,
        "iColorA": 71
    },
    {
        "lEstadoExpedicion_id": 5,
        "sDescripcion": "COMPLETADA",
        "sCodigo": "C",
        "iColorR": 16,
        "iColorV": 224,
        "iColorA": 224
    }
]

// create a component
class ExpedicionEstado extends Component {
    render() {

        const estado = DATA.find((item) => item.sDescripcion == this.props.estado);


        return <Text style={[{
            backgroundColor: `rgba(${estado.iColorR},${estado.iColorV},${estado.iColorA},0.25)`,
            color: STheme.color.text,
            borderColor: `rgba(${estado.iColorR},${estado.iColorV},${estado.iColorA},1)`,
            borderWidth: 1,
            padding:1,
            borderRadius: 4,
            paddingStart: 4,
            paddingEnd: 4,
            textAlign: "center",
            fontSize: 12,
            fontWeight: "500",
            textTransform: "uppercase",
            
        }, this.props.style]} numberOfLines={this.props.wrap ? 0 : 1}>{this.props.estado}</Text>
    }
}


//make this component available to the app
export default ExpedicionEstado;
